module.exports = __webpack_public_path__ + "static/media/pixi.1c0cce3f.svg";